import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../../types/store';

import { applyLastFilters, saveLastFilters } from '../../../store/last_filters/actions';
import { ExtraFilters, IExtraFiltersDispatchProps, IExtraFiltersStoreProps } from './index';

export function mapStateToProps(state: IApplicationState): IExtraFiltersStoreProps {
  return {
    savedFilters: state.savedFilters,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    applyLastFilters: () => dispatch(applyLastFilters()),
    saveLastFilters: () => dispatch(saveLastFilters()),
  };
}

export const ExtraFiltersContainer = connect<IExtraFiltersStoreProps, IExtraFiltersDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(ExtraFilters);
